"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconHomeFilled = props => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  viewBox: "0 0 20 20",
  ...props,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
      id: "hfa",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M1440 0v1892H0V0h1440Z"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
      id: "hfb",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m9 0 9 7v12H0V7l9-7Z"
      })
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    clipPath: "url(#hfa)",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      clipPath: "url(#hfb)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M0 0h18v19H0V0z"
      })
    })
  })]
});
var _default = exports.default = (0, _withIcon.default)('IconHomeFilled')(IconHomeFilled);